export default function (state, val) {
    let id = val ? (val.id ? val.id : '') : '';
    let item, newFilter;
    if (id) {
        item = state.filters.filter(i => {
            return i.id === val.id;
        })[0];
    }
    if (!item) {
        newFilter = true;
        item = {
            id: '' + new Date().getTime(),
            name: 'Фильтр ' + (state.filters.length + 1),
            searchClick: true,
            dateStep: 1,
            dateInt: 0,
            dateRound: false,

            AccountId: '',
            SubAccountId: '',
            ContragentId: '',
            ContragentName: '',
            CurrencyId: '',
            PaymentAccountId: '',
            WithTurns: false,
            WithDocumens: false,
        }
    }
    if (val) {
        for (let k in val) {
            if (typeof item[k] !== 'undefined') item[k] = val[k];
        }
    }
    if (newFilter) {
        state.filters.push(item);
    }
}